<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableEnterpriseWechatRobotDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          v-hasPermission="['alarm_contact:AlarmContact:robot_log']"
          @click="rowClick(row)"
          >{{ $t("alarm_contact.operationLog") }}</Button
        >
        <Button
          type="success"
          size="small"
          @click="edit(row)"
        >{{ $t("alarm_contact.edit") }}</Button
        >
        <span @click="doDelete(index)">
          <!-- deleteFlag:false 有关联不能删除 -->
          <Button
            type="error"
            size="small"
            v-hasPermission="['alarm_contact:AlarmContactWechatRobot:delete']"
            :disabled="row.deleteFlag == false"
            @click="alarmContactDelmodal = true"
            >{{ $t("alarm_contact.del") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志 -->
    <Modal
      :title="$t('operation_log.operationLog')"
      v-model="dialogVisible"
      width="55%"
      footer-hide
    >
      <Table
        :no-data-text="$t('common.noData')"
        :columns="column"
        :data="alertRuleOperationLogDate"
        style="width: 100.1%;"
        class="table-css"
        height="500"
      ></Table>
    </Modal>

    <!-- 删除报警联系人模式框 -->
    <Modal v-model="alarmContactDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ deleteName }} ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="remove()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <Modal
      v-model="addEditModal"
      :title="$t('alarms.common.edit')"
      :loading="loading"
      @on-ok="submit('enterpriseWechatRobotForm')"
      @on-cancel="cancel('enterpriseWechatRobotForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.edit')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="enterpriseWechatRobotForm"
        :model="enterpriseWechatRobotForm"
        :label-width="130"
        :rules="ruleValidate"
      >
        <!-- 机器人名称 -->
        <FormItem :label="$t('alarm_contact.robotName')" prop="name">
          <Input
            type="text"
            v-model="enterpriseWechatRobotForm.name"
            style="width:300px;"
          ></Input>
        </FormItem>

        <!-- 公司 -->
        <div v-if="company == 1">
          <FormItem :label="$t('alarm_contact.companyName')" prop="companyId">
            <Select
              filterable
              v-model="companyId"
              style="width:300px;"
              placeholder=""
            >
              <Option
                :value="item.id"
                v-for="(item, index) in companyList"
                v-bind:key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>

        <!-- 企业微信机器人URL -->
        <FormItem
          :label="$t('alarms.common.enterpriseWeChatRobotURL')"
          prop="webhookUrl"
        >
          <Input
            type="text"
            v-model="enterpriseWechatRobotForm.webhookUrl"
            style="width:300px;"
          ></Input>
        </FormItem>

        <!-- 监控模块 -->
        <FormItem
          :label="$t('alarm_contact.monitorModule')"
          prop="monitorModule"
        >
          <Select
            filterable
            v-model="enterpriseWechatRobotForm.monitorModule"
            multiple
            style="width:300px;"
            placeholder=""
          >
            <Option
              :value="item.id"
              v-for="item in monitorModuleList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import AddEnterpriseWechatRobot from "../enterprise_wechat_robot/AddEnterpriseWechatRobot";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";

var tableEnterpriseWechatRobotVue = {};
export default {
  name: "TableAlarmContact",
  components: { AddEnterpriseWechatRobot },
  data() {
    return {
      dialogVisible: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      alarmContactDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      deleteName: "",
      company: getCookie(global.companyId),
      companyId: "",
      userCompanyId: "",
      companyList: [],
      loading: true,
      addEditModal: false,
      monitorModuleList: [],
      enterpriseWechatRobotForm: {
        name: "",
        webhookUrl: "",
        monitorModule: []
      },
      ruleValidate: {
        name: [
          { required: true, message: this.$t("alarm_contact.robotNameRequired"), trigger: "blur" }
        ],
        webhookUrl: [
          {
            required: true,
            message: this.$t("alarm_contact.robotUrlRequired"),
            trigger: "blur"
          }
        ],
        monitorModule: [
          {
            required: true,
            message: this.$t("alarm_contact.selectMonitorModule"),
            trigger: "change",
            type: "array"
          }
        ]
      },
      columns: [
        {
          title: this.$t('alarm_contact.robotName'),
          key: "name"
        },
        {
          title: this.$t("alarm_contact.companyName"),
          key: "companyName"
        },
        {
          title: this.$t("alarms.common.enterpriseWeChatRobotURL"),
          key: "webhookUrl"
        },
        {
          title: this.$t("alarm_contact.monitorModule"),
          key: "monitorModuleNames"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      column: [
        {
          title: this.$t("operation_log.operationFieldName"),
          key: "operationTypeName"
        },
        {
          title: this.$t("operation_log.operationOriginValue"),
          key: "operationOriginValue"
        },
        {
          title: this.$t("operation_log.operationNewValue"),
          key: "operationNewValue"
        },
        {
          title: this.$t("operation_log.createdBy"),
          key: "createdBy"
        },
        {
          title: this.$t("operation_log.createdTime"),
          key: "createdTime"
        }
      ],
      tableEnterpriseWechatRobotDate: [],
      alertRuleOperationLogDate: []
    };
  },
  beforeCreate: function() {
    tableEnterpriseWechatRobotVue = this;
  },
  mounted: function() {
    tableEnterpriseWechatRobotVue.getData();
    if (this.company == 1) {
      tableEnterpriseWechatRobotVue.getCompanyDropDownBox();
    }
    // 查询监控模块和报警用户
    tableEnterpriseWechatRobotVue.searchMonitorModule();
  },
  methods: {
    edit(row) {
      this.addEditModal = true; //编辑账户弹出层
      this.enterpriseWechatRobotForm.id = row.id;
      this.$api.enterpriseWechatRobot
        .getEnterpriseWechatRobotInfoById("id", row.id)
        .then(res => {
          // 机器人名称
          this.enterpriseWechatRobotForm.name = res.data.name;
          // 公司
          this.companyId = res.data.companyId;
          // 企业微信机器人URL
          this.enterpriseWechatRobotForm.webhookUrl =
            res.data.webhookUrl;
          // 监控模块
          this.enterpriseWechatRobotForm.monitorModule =
            res.data.monitorModules;
        });
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 查询监控模块和报警用户
    searchMonitorModule: function() {
      this.$api.alertRule
        .searchMonitorModule("userName", getCookie(global.cookieName))
        .then(res => {
          this.monitorModuleList = res.data;
        });
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.dialogVisible = true;
      this.$api.enterpriseWechatRobotOperationLog
        .listOperationLogs("id", row.id)
        .then(res => {
          this.alertRuleOperationLogDate = res.data;
        });
    },
    showAll: function() {
      tableEnterpriseWechatRobotVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      eventBus.$on("name", function(val) {
        tableEnterpriseWechatRobotVue.val = val;
      });
      eventBus.$on("userCompanyId", function(val) {
        tableEnterpriseWechatRobotVue.userCompanyId = val;
      });
      this.$api.enterpriseWechatRobot
        .pagingQuery({
          companyId: tableEnterpriseWechatRobotVue.userCompanyId,
          name: tableEnterpriseWechatRobotVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableEnterpriseWechatRobotDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableEnterpriseWechatRobotVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableEnterpriseWechatRobotVue.getData();
    },
    // 销毁name
    beforeDestroy: function() {
      eventBus.$off("name");
      eventBus.$off("userCompanyId");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.deleteName = this.tableEnterpriseWechatRobotDate[index].name;
    },
    remove: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      this.$api.enterpriseWechatRobot
        .delete("id", this.tableEnterpriseWechatRobotDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableEnterpriseWechatRobotVue.getData();
            this.isDisable = false;
            this.modal_loading = false;
            this.alarmContactDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    submit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 编辑
          tableEnterpriseWechatRobotVue.$api.enterpriseWechatRobot
            .createOrUpdate({
              id: this.enterpriseWechatRobotForm.id,
              name: this.enterpriseWechatRobotForm.name,
              companyId:
                this.companyId == null ||
                this.companyId == "" ||
                this.companyId == undefined
                  ? this.company
                  : this.companyId,
              webhookUrl: this.enterpriseWechatRobotForm.webhookUrl,

              monitorModules: this.enterpriseWechatRobotForm.monitorModule
            })
            .then(res => {
              setTimeout(() => {
                tableEnterpriseWechatRobotVue.getData();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t("common.editSuccess"));
                this.addEditModal = false;
              }, 1000);
            });
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.editFail"));
        }
      });
    },
    cancel: function(name) {
      this.addEditModal = false;
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
/* 滚动条 */
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #ccc;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
  background: #eeeeef;
}
.table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
  background-color: #eeeeef;
}
.table-css >>> .ivu-table-overflowX {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/enterprise_wechat_robot/TableEnterpriseWechatRobot.vue